import { render, staticRenderFns } from "./ConsignmentFormPage.vue?vue&type=template&id=6b08b610&"
import script from "./ConsignmentFormPage.vue?vue&type=script&lang=js&"
export * from "./ConsignmentFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports